import { apiErrorDetails, apiErrorMessageKey } from '~/utils/apiError'

/**
 * The translation key for a failed API request, from the error code the API
 * sends or, from older API builds, the HTTP status. The code may arrive on the
 * error itself or on the error body wrapped in `data`.
 */
export function getProjectUpdateErrorKey(error: unknown): string {
  return apiErrorMessageKey(apiErrorDetails(error))
}
